module.exports = __webpack_public_path__ + "static/media/1POLICY8.8f69f2be.jpg";